import router from '@/router';

export default {
	state:
		{
            userMsg: {},
            successInfo:{}
		},
	getters: {},
	mutations:
		{
			setUserMsg (state: any, list: Object) {
        		state.userMsg = list;
            },
            setSuccess(state: any, data: Object) {
                console.log('=========>',state,data)
                state.successInfo = data;
            }
		},
	actions:
		{
     		async gitGiftCardList ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('ZUKER_GET_GIFTCARD_LIST', params);
				return { error, success };
			},
			async gitGiftCardInfo ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('ZUKER_GET_GIFTCARD_INFO', params);
				return { error, success };
            },

            //获取验证码
            async gitMsgCode ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('ZUKER_GET_MSGCODE', params);
				return { error, success };
            },

            async writeoffCard ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('ZUKER_WRITEOFF_GIFTCARD', params);
				return { error, success };
            },

            async getWriteoffList ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('ZUKER_WRITEOFF_LIST', params);
				return { error, success };
			},

			async getWriteoffNotRefundList ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('ZUKER_WRITEOFF_NOTREFUNDLIST', params);
				return { error, success };
			},
			

            async writeoffConfirm ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('ZUKER_WRITEOFF_CONFIRM', params);
				return { error, success };
            },

            async writeoffDetail ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('ZUKER_WRITEOFF_DETAIL', params);
				return { error, success };
            },
    },

};